import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Panel} from 'react-bootstrap';
import classNames from 'classnames';

export default class ExpandablePanel extends Component {
    static propTypes = {
        expanded: PropTypes.bool,
        onHeaderClick: PropTypes.func,
        isExpandable: PropTypes.bool
    };

    static defaultProps = {
        onHeaderClick: () => {}
    };

    constructor(props) {
        super(props);
        this.state = {expanded: !!props.expanded};
    }

    handleHeaderClick = () => {
        this.setState({expanded: this.props.isExpandable === false ? false : !this.state.expanded});

        if (this.props.onHeaderClick) {
            this.props.onHeaderClick(!this.state.expanded);
        }
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({expanded: this.state.expanded || !!nextProps.expanded});
    }

    render() {
        const {expanded} = this.state;
        const headerClass = classNames('fa', expanded ? 'fa-chevron-down' : 'fa-chevron-right');
        const header = (
            <div onClick={this.handleHeaderClick}>
                <span>{this.props.header} </span>
                {this.props.isExpandable === false ? null : <i className={headerClass} />}
            </div>
        );

        const panelClass = classNames('expandable-panel', expanded ? 'expanded' : null);

        return (
            <Panel {...this.props} header={header} className={panelClass}>
                {expanded && this.props.children}
            </Panel>
        );
    }
}



// WEBPACK FOOTER //
// ./components/expandable_panel.js